import { render } from "./AvatarGallery.vue?vue&type=template&id=119efc4d"
import script from "./AvatarGallery.vue?vue&type=script&lang=js"
export * from "./AvatarGallery.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__